(function () {
  var drawer = document.querySelector('[data-cart-drawer]');
  var overlay = document.querySelector('[data-cart-overlay]');
  var drawerItems = document.querySelector('[data-drawer-items]');
  var drawerFooter = document.querySelector('[data-drawer-footer]');
  var emptyState = document.querySelector('[data-cart-empty]');
  var previousFocus = null;
  var timerInterval = null;

  function route(path) {
    var root = window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/';
    return root + path;
  }

  function money(cents, currency) {
    var activeCurrency = currency || (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: activeCurrency }).format((Number(cents) || 0) / 100);
    } catch (error) {
      return '$' + ((Number(cents) || 0) / 100).toFixed(2);
    }
  }

  function updateCount(cart) {
    document.querySelectorAll('[data-cart-count]').forEach(function (count) {
      count.textContent = cart.item_count;
      count.hidden = cart.item_count < 1;
    });
    var headingCount = document.querySelector('[data-drawer-count]');
    if (headingCount) headingCount.textContent = cart.item_count;
    var heading = document.querySelector('#HGCartHeading');
    if (heading) heading.setAttribute('aria-label', 'Cart, ' + cart.item_count + ' items');
  }

  function element(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text !== undefined) node.textContent = text;
    return node;
  }

  function renderCart(cart) {
    if (!cart || !drawerItems) return;
    updateCount(cart);
    drawerItems.replaceChildren();
    var savings = 0;
    var currency = cart.currency || undefined;

    cart.items.forEach(function (item) {
      var originalLine = Number(item.original_line_price || item.line_price || 0);
      var finalLine = Number(item.final_line_price || item.line_price || 0);
      var originalUnit = Number(item.original_price || item.price || 0);
      var finalUnit = Number(item.final_price || item.price || 0);
      savings += Math.max(originalLine - finalLine, 0);

      var row = element('article', 'hg-drawer-item');
      var image = element('img', 'hg-drawer-item-image');
      image.src = item.image || (window.HolidayGlowTheme && HolidayGlowTheme.fallbackImage) || '';
      image.alt = item.product_title || item.title || 'Product';
      image.loading = 'lazy';
      row.appendChild(image);

      var info = element('div', 'hg-drawer-item-info');
      info.appendChild(element('h3', '', item.product_title || item.title || 'Product'));
      var unit = element('div', 'hg-drawer-unit-price');
      if (originalUnit > finalUnit) unit.appendChild(element('s', '', money(originalUnit, currency)));
      unit.appendChild(element('strong', '', money(finalUnit, currency)));
      var bundleName = item.properties && (item.properties._bundle_label || item.properties.Bundle);
      if (!bundleName && item.quantity > 1) bundleName = 'Buy ' + item.quantity;
      if (bundleName) unit.appendChild(element('span', 'hg-bundle-tag', bundleName));
      info.appendChild(unit);

      var quantity = element('div', 'hg-drawer-quantity');
      var minus = element('button', '', '−');
      minus.type = 'button';
      minus.setAttribute('aria-label', 'Decrease quantity of ' + (item.product_title || item.title));
      var quantityValue = element('span', '', String(item.quantity));
      var plus = element('button', '', '+');
      plus.type = 'button';
      plus.setAttribute('aria-label', 'Increase quantity of ' + (item.product_title || item.title));
      minus.addEventListener('click', function () { changeQuantity(item.key, Math.max(item.quantity - 1, 0)); });
      plus.addEventListener('click', function () { changeQuantity(item.key, item.quantity + 1); });
      quantity.append(minus, quantityValue, plus);
      info.appendChild(quantity);
      row.appendChild(info);

      var total = element('div', 'hg-drawer-line-total');
      var totalPrices = element('div');
      if (originalLine > finalLine) totalPrices.appendChild(element('s', '', money(originalLine, currency)));
      totalPrices.appendChild(element('strong', '', money(finalLine, currency)));
      total.appendChild(totalPrices);
      if (originalLine > finalLine) total.appendChild(element('p', '', '(You save ' + money(originalLine - finalLine, currency) + ')'));
      row.appendChild(total);

      var remove = element('button', 'hg-drawer-remove');
      remove.type = 'button';
      remove.setAttribute('aria-label', 'Remove ' + (item.product_title || item.title) + ' from cart');
      remove.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 7h16M9 7V4h6v3m3 0-.8 13H6.8L6 7m4 3v7m4-7v7"/></svg>';
      remove.addEventListener('click', function () { changeQuantity(item.key, 0); });
      row.appendChild(remove);
      drawerItems.appendChild(row);
    });

    var savingsNode = document.querySelector('[data-cart-savings]');
    var subtotalNode = document.querySelector('[data-cart-subtotal]');
    if (savingsNode) savingsNode.textContent = '−' + money(savings, currency);
    if (subtotalNode) subtotalNode.textContent = money(cart.total_price, currency);
    if (emptyState) emptyState.hidden = cart.item_count !== 0;
    if (drawerFooter) drawerFooter.hidden = cart.item_count === 0;
  }

  function fetchCart() {
    return fetch(route('cart.js'), { headers: { Accept: 'application/json' } }).then(function (response) {
      if (!response.ok) throw new Error('Could not load the cart.');
      return response.json();
    });
  }

  function changeQuantity(key, quantity) {
    fetch(route('cart/change.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (response) {
      if (!response.ok) throw new Error('Could not update the cart.');
      return response.json();
    }).then(renderCart).catch(function () { fetchCart().then(renderCart); });
  }

  function updateTimer() {
    var timer = document.querySelector('[data-cart-timer]');
    if (!timer) return;
    var expiresAt = 0;
    try { expiresAt = Number(sessionStorage.getItem('hgCartReservedUntil')) || 0; } catch (error) {}
    if (!expiresAt || expiresAt < Date.now()) {
      expiresAt = Date.now() + 5 * 60 * 1000;
      try { sessionStorage.setItem('hgCartReservedUntil', String(expiresAt)); } catch (error) {}
    }
    function tick() {
      var seconds = Math.max(0, Math.floor((expiresAt - Date.now()) / 1000));
      timer.textContent = String(Math.floor(seconds / 60)).padStart(2, '0') + ':' + String(seconds % 60).padStart(2, '0');
    }
    if (timerInterval) window.clearInterval(timerInterval);
    tick();
    timerInterval = window.setInterval(tick, 1000);
  }

  function openDrawer(cart) {
    if (!drawer || !overlay) return;
    previousFocus = document.activeElement;
    drawer.hidden = false;
    overlay.hidden = false;
    document.body.classList.add('hg-cart-open');
    requestAnimationFrame(function () {
      drawer.classList.add('is-open');
      overlay.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      drawer.focus();
    });
    updateTimer();
    if (cart) renderCart(cart);
    else fetchCart().then(renderCart);
  }

  function closeDrawer() {
    if (!drawer || !overlay) return;
    drawer.classList.remove('is-open');
    overlay.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('hg-cart-open');
    if (timerInterval) window.clearInterval(timerInterval);
    window.setTimeout(function () {
      drawer.hidden = true;
      overlay.hidden = true;
    }, 260);
    if (previousFocus && previousFocus.focus) previousFocus.focus();
  }

  if (overlay) overlay.addEventListener('click', closeDrawer);
  document.querySelectorAll('[data-cart-close]').forEach(function (button) { button.addEventListener('click', closeDrawer); });
  document.querySelectorAll('[data-cart-continue]').forEach(function (button) { button.addEventListener('click', closeDrawer); });
  document.querySelectorAll('[data-cart-trigger]').forEach(function (link) {
    link.addEventListener('click', function (event) {
      event.preventDefault();
      fetchCart().then(openDrawer).catch(function () { window.location.href = link.href; });
    });
  });
  document.addEventListener('keydown', function (event) { if (event.key === 'Escape' && drawer && !drawer.hidden) closeDrawer(); });

  function initProduct(root) {
    if (!root || root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';
    var quantityInputs = root.querySelectorAll('[data-bundle-quantity]');
    var labelInputs = root.querySelectorAll('[data-bundle-label]');
    var cards = root.querySelectorAll('[data-bundle-card]');

    root.querySelectorAll('input[name="hg-bundle"]').forEach(function (input) {
      input.addEventListener('change', function () {
        cards.forEach(function (card) { card.classList.remove('is-selected'); });
        var selected = input.closest('[data-bundle-card]');
        if (selected) selected.classList.add('is-selected');
        quantityInputs.forEach(function (field) { field.value = input.dataset.quantity || input.value; });
        labelInputs.forEach(function (field) { field.value = 'Buy ' + (input.dataset.quantity || input.value); });
      });
    });

    root.querySelectorAll('[data-gallery-thumb]').forEach(function (button) {
      button.addEventListener('click', function () {
        var index = button.dataset.galleryThumb;
        root.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
          var active = thumb === button;
          thumb.classList.toggle('is-active', active);
          thumb.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
        root.querySelectorAll('[data-gallery-image]').forEach(function (image) {
          var active = image.dataset.galleryImage === index;
          image.hidden = !active;
          image.classList.toggle('is-active', active);
        });
      });
    });

    var reviewCards = root.querySelectorAll('[data-spotlight-review]');
    var reviewDots = root.querySelectorAll('[data-review-dot]');
    reviewDots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        var index = dot.dataset.reviewDot;
        reviewCards.forEach(function (review) {
          var active = review.dataset.spotlightReview === index;
          review.hidden = !active;
          review.classList.toggle('is-active', active);
        });
        reviewDots.forEach(function (other) {
          var active = other === dot;
          other.classList.toggle('is-active', active);
          other.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
      });
    });

    var mainForm = root.querySelector('[data-cart-form]');
    var stickyButton = document.querySelector('[data-sticky-add]');
    if (stickyButton && mainForm) stickyButton.addEventListener('click', function () { mainForm.requestSubmit(); });
    if (mainForm) {
      mainForm.addEventListener('submit', function (event) {
        event.preventDefault();
        var submitButton = mainForm.querySelector('button[type="submit"]');
        var status = mainForm.querySelector('[data-add-status]');
        if (submitButton) submitButton.disabled = true;
        if (status) status.textContent = 'Adding…';
        fetch(route('cart/add.js'), { method: 'POST', body: new FormData(mainForm), headers: { Accept: 'application/json' } })
          .then(function (response) {
            if (!response.ok) throw new Error('Could not add this item.');
            return response.json();
          })
          .then(fetchCart)
          .then(function (cart) {
            if (status) status.textContent = 'Added to cart.';
            openDrawer(cart);
          })
          .catch(function () {
            if (status) status.textContent = 'Taking you to your cart…';
            mainForm.submit();
          })
          .finally(function () { if (submitButton) submitButton.disabled = false; });
      });
    }
  }

  document.querySelectorAll('[data-hg-product]').forEach(initProduct);
  var sticky = document.querySelector('[data-sticky-atc]');
  if (sticky) {
    function updateSticky() { sticky.classList.toggle('is-visible', window.scrollY > 520); }
    window.addEventListener('scroll', updateSticky, { passive: true });
    updateSticky();
  }
})();
